function Facebook() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'>
      <circle cx='22.5' cy='22.5' r='20' fill='#fff'></circle>
      <path
        fill='#5d2e7a'
        d='M24.6 35.5V24.6h3.7l.6-4.3h-4.2v-2.7c0-1.2.3-2.1 2.1-2.1h2.3v-3.8l-3.3-.2c-3.3 0-5.5 2-5.5 5.6v3.1h-3.8v4.3h3.7v11h4.4z'
      ></path>
    </svg>
  );
}

export default Facebook;
